// Vendor imports
const _ = require('lodash')
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const withIsVisible = require('client-v2/common/components/is-visible')
// Entry imports
const ConfirmModal = require('./component-dumb')

function mapStateToProps(state) {
  const { confirmModal } = state
  if (!confirmModal) {
    return { isVisible: false }
  }
  const props = _.pick(confirmModal, [
    'dismissOnBackdropClick',
    'hasBackdrop',
    'hasCloseButton',
    'buttons',
    'heading',
    'subheading',
    'onConfirm'
  ])
  return { isVisible: true, ...props }
}

module.exports = connect(
  mapStateToProps
)(
  withIsVisible(
    withImmutableToJS(
      ConfirmModal
    )
  )
)
